export default {
  "title": {
    "ranking": "Ranking de conductores",
    "mainIndicators": "Principales indicadores para cálculo de la nota conductual del periodo",
    "dailyBehaviorGrade": "Nota conductual diaria"
  },
  "help": {
    "mainIndicators": "Cada uno de estos indicadores se calcula en función de la cantidad de eventos registrado por viaje, la duración del viaje y los kilómetros recorridos en el periodo de fechas seleccionado."
  },
  "labels": {
    "behaviorGrade": "Nota conductual"
  },
  "graphTooltip": {
    "behaviorGrade": "Nota día"
  },
  "table": {
    "ranking": "Nº Ranking",
    "driverName": "Nombre conductor",
    "behaviorGrade": "Nota conductual"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/behavior/detailBehavior.js